module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "srm-client-scroll"
  }, [_c('el-carousel', {
    attrs: {
      "indicator-position": "none",
      "arrow": "always",
      "interval": 5000
    }
  }, _vm._l((_vm.testimonialsCon), function(item) {
    return _c('el-carousel-item', {
      key: item.id
    }, [_c('div', {
      staticClass: "rel carousel-content"
    }, [(item.video_link) ? _c('div', {
      staticClass: "abs carousel-img-video cp",
      on: {
        "click": function($event) {
          return _vm.openVideoPlayer(item.video_link)
        }
      }
    }, [_c('img', {
      class: item.logo ? 'has-logo' : '',
      attrs: {
        "src": require("../../assets/img/index/video.png"),
        "alt": "logo"
      }
    })]) : _vm._e(), _vm._v(" "), (item.logo) ? _c('div', {
      staticClass: "abs logo-img cp",
      class: item.video_link ? 'has-video' : ''
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.logo),
        expression: "$global.globalPath + item.logo"
      }],
      attrs: {
        "alt": "logo"
      }
    })]) : _vm._e(), _vm._v(" "), (item.video_link) ? _c('div', {
      staticClass: "abs carousel-img cp"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.img),
        expression: "$global.globalPath + item.img"
      }],
      attrs: {
        "alt": "logo"
      }
    })]) : _vm._e(), _vm._v(" "), (!item.video_link) ? _c('div', {
      staticClass: "abs carousel-img"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.img),
        expression: "$global.globalPath + item.img"
      }],
      attrs: {
        "alt": item.img
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "abs carousel-desc"
    }, [_c('div', {
      staticClass: "carousel-desc-w"
    }, [_c('div', {
      staticClass: "deco_icon"
    }, [_vm._v("“")]), _vm._v(" "), _c('p', {
      staticClass: "tl desc"
    }, [_vm._v("\n              " + _vm._s(item.speech) + "\n            ")]), _vm._v(" "), _c('h1', {
      staticClass: "tr company-name"
    }, [_vm._v(" —" + _vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "link"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.goConsult()
        }
      }
    }, [_vm._v("咨询案例详情 > ")])])])])])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "index-video"
  }, [_c('el-dialog', {
    attrs: {
      "custom-class": "customClass",
      "visible": _vm.centerDialogVisible,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      },
      "close": _vm.closeVideoDialog
    }
  }, [_c('div', {
    staticClass: "video-test"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVideoImg),
      expression: "showVideoImg"
    }],
    staticClass: "video-img tc cp",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.videoPlay.apply(null, arguments)
      }
    }
  }, [_c('h1', {
    staticClass: "video-title dib"
  }, [_vm._v(_vm._s(_vm.videoText))])]), _vm._v(" "), _c('div', {
    staticClass: "homeDialog-video",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.videoClick.apply(null, arguments)
      }
    }
  }, [_c('video', {
    attrs: {
      "src": _vm.videoPlayData,
      "id": "homeVideo",
      "preload": "auto",
      "controls": "",
      "autoplay": "",
      "controlsList": "nodownload"
    },
    on: {
      "seeked": _vm.videoSeek,
      "pause": _vm.videoClick,
      "error": _vm.videoError,
      "ended": _vm.videoDown
    }
  })])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02bfc688"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/speechSwiper.vue
// module id = 377
// module chunks = 12